// import { AdminSideBar } from "../components/UserSideBar";
import { allPaymentStatus, allStatusListItems } from "../../../data/CategoriesData"
import { RiyalImgBLK } from '../../../components/common/RiyalImg';
import { useAdminPayment } from '../../../context/Admins/AdminPaymentContext';

import moment from 'moment';
import Pagination from "../../../utilities/Pagination"
import UserSampleImg from '../../../assets/defaults/user0-img.jpg';

export function SettingPayments() {
    const { paymentData, currentPage, setCurrentPage,
        searchQuery, setSearchQuery, setSelectedPaymentStatus } = useAdminPayment();
    const totalPages = paymentData?.data?.paginationInfo.totalPagesCount;

    const AdminOrder = ({ index, paymentId, paymentType, orderCreated, orderUser, orderImg, paymentStatus, orderStatusEn, paymentAmount }) => (
        <>
            <tr key={index}
                className={`${orderStatusEn === "Rejected"
                    && "table-danger"} ${orderStatusEn === "Quotation Process"
                    && "table-warning"} align-content-center`}>
                <td className="col" > {`${moment(orderCreated).format('YY')}${new Intl.NumberFormat("en-IN", { minimumIntegerDigits: 2 }).format(
                    paymentId,)}${new Intl.NumberFormat("en-IN", { minimumIntegerDigits: 3 }).format(paymentId,)}`
                }</td>
                <td className="col-2">
                    {moment(orderCreated).format('DD-MM-YYYY')}</td>
                <td className="col">{paymentType === "services" ? "خدمات" : "كتب"}</td>
                <td className="col"><img className="small-profile-image me-1" crossOrigin="anonymous" src={orderImg ? orderImg : UserSampleImg} alt="" />{orderUser}</td>
                <td className="col">{paymentAmount} <RiyalImgBLK /></td>
                <td className="col">{allPaymentStatus.find(item => item.en === paymentStatus)?.ar || ""}</td>

            </tr>
        </>);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };
    const filteredPaymentData = paymentData?.data?.result.filter(item =>
        // item.orderType.toLowerCase().includes(searchQuery.toLowerCase()) ||
        // item.status.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.amount.toString().includes(searchQuery) ||
        item.createdAt.includes(searchQuery)
    );


    // if (error) {
    //     return <div className="text-center my-4 text-danger">{error}</div>;
    // }
    if (!paymentData) {
        return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    }
    moment.locale('en');

    return (
        <div className="container my-3 rounded bg-light-gray position-relative p-3 ">
            <div className="d-flex gap-1 flex-wrap justify-content-center ">
                <input
                    name="queryPayment"
                    className="form-control-sm border-0 w-auto"
                    type="search"
                    placeholder="بحث"
                    value={searchQuery}
                    onChange={handleSearchChange} />
                <div className="container position-relative p-3 overflow-auto">
                    <div className="form-floating">
                        <select className="form-select form-select-sm w-75 mb-2"
                            id="select-status"
                            onChange={e => setSelectedPaymentStatus(e.target.value)}>
                            <option value="">الكل</option>
                            {allPaymentStatus.map((oneStatus, index) =>
                                <option key={index} value={oneStatus.en}>{oneStatus.ar}</option>
                            )}
                        </select>
                        <label htmlFor="select-status">حالة الدفع</label>
                    </div>
                    <table className="table table-hover align-middle">
                        <thead className="table-dark">
                            <tr>
                                <th scope="col">كود</th>
                                <th scope="col">التاريخ</th>
                                <th scope="col">نوع الدفع</th>
                                <th scope="col">العميل</th>
                                <th scope="col">المبلغ</th>
                                <th scope="col">الحالة</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(searchQuery ? filteredPaymentData : paymentData)
                                .data?.result.map((order) => (
                                    order.amount > 1 &&
                                    <AdminOrder
                                        key={order.id}
                                        paymentId={order.id}
                                        orderCreated={order.createdAt}
                                        paymentType={order.orderType}
                                        orderUser={order.user.firstName}
                                        orderImg={order.user.image}
                                        orderUserID={order.user.id}
                                        paymentStatus={order.status}
                                        numberOfForms={order.numberOfForms}
                                        language={order.language}
                                        orderDescription={order.description}
                                        subServices={order.subServices}
                                        offerStatus={allStatusListItems.map(oneStatus => oneStatus.en === order.offerDetails?.status ? oneStatus.ar : "")}
                                        paymentAmount={order.amount}
                                    />
                                ))}
                        </tbody>
                    </table>
                </div>
                {totalPages > 1 &&
                    <Pagination
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalPages={totalPages} />
                }
            </div>
        </div>
    )
}